// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3AvvZ","modalForm":"UpgradeEpcsModal_modalForm__GjJo8","modalFooter":"UpgradeEpcsModal_modalFooter__3BdWZ"};